import { render, staticRenderFns } from "./McuLayanan.vue?vue&type=template&id=5bbd917d"
import script from "./McuLayanan.vue?vue&type=script&lang=js"
export * from "./McuLayanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports